
export const getViewPointConfig = (
  dataId,
  label,
  color
) => {
  let viewPoint = {
    id: dataId,
    type: "point",
    config: {
      dataId: dataId,
      label: label,
      color: color,
      highlightColor: color,
      columns: {
        lat: "lat",
        lng: "lon",
        altitude: null,
      },
      isVisible: true,
      visConfig: {
        radius: 20,
        fixedRadius: false,
        opacity: 1,
        outline: false,
        thickness: 2,
        strokeColor: null,
        radiusRange: [0, 50],
        filled: true,
      },
      hidden: false,
    },
  }
  return viewPoint

}




